var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFemale(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.20078 4.86299C9.20078 2.69326 7.32224 0.9375 5.00078 0.9375C2.67933 0.9375 0.800781 2.69326 0.800781 4.86299C0.800781 6.79005 2.28224 8.38166 4.23715 8.71711V10.2159H2.70987V11.6434H4.23715V13.0708H5.76442V11.6434H7.29169V10.2159H5.76442V8.71711C7.71933 8.38166 9.20078 6.79005 9.20078 4.86299ZM2.32805 4.86299C2.32805 3.4855 3.52696 2.36495 5.00078 2.36495C6.4746 2.36495 7.67351 3.4855 7.67351 4.86299C7.67351 6.24048 6.4746 7.36103 5.00078 7.36103C3.52696 7.36103 2.32805 6.24048 2.32805 4.86299Z",
    fill: "#1B7EB3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFemale);
export default __webpack_public_path__ + "static/media/Female.480911c29a5e9f4b588d62fa48e5cfb8.svg";
export { ForwardRef as ReactComponent };